import '@tencent/exeditor3-ui-kit/dist/toolbar-divider.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-fold.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export class ToolbarCommonItemsPlugin {
    constructor() {
        this.name = 'toolbar-common-items';
        this.priority = 10;
        this.renderToolbarItem = {
            '|': () => document.createElement('exeditor-toolbar-divider'),
            fold: (context, params = '') => {
                const btn = document.createElement('exeditor-toolbar-fold');
                btn.appendChild(createIcon({
                    name: 'fold',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.foldIcon),
                }));
                const renderContext = {
                    ...context,
                    in: 'dropdown',
                    editor: this.editor,
                };
                const buttonCollection = [];
                const bindDropdownOpenEvent = (button) => {
                    buttonCollection.push(button);
                    return () => {
                        buttonCollection.forEach((otherButton) => {
                            var _a, _b;
                            if (otherButton === button) {
                                if (!button.disabled) {
                                    (_a = otherButton.openDropdown) === null || _a === void 0 ? void 0 : _a.call(otherButton);
                                }
                            }
                            else {
                                (_b = otherButton.closeDropdown) === null || _b === void 0 ? void 0 : _b.call(otherButton);
                            }
                        });
                    };
                };
                params
                    .trim()
                    .split(/\s+/)
                    .forEach((name) => {
                    const itemRenderer = context.getItemRenderer(name);
                    if (!itemRenderer) {
                        return;
                    }
                    const eltItem = itemRenderer(renderContext);
                    eltItem.setAttribute('slot', 'item');
                    eltItem.setAttribute('in', renderContext.in || '');
                    eltItem.addEventListener('mouseenter', bindDropdownOpenEvent(eltItem));
                    btn.appendChild(eltItem);
                });
                return btn;
            },
            undo: () => {
                const btn = document.createElement('exeditor-toolbar-button');
                Object.assign(btn, {
                    label: this.editor.t('撤消'),
                    shortcut: 'Mod-z',
                    onclick: () => {
                        this.editor.focus().undo();
                    },
                }).appendChild(createIcon({
                    name: 'undo',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.undoIcon),
                }));
                const setBtnProps = () => {
                    btn.disabled = !this.editor.canUndo();
                };
                setBtnProps();
                this.editor.on('idlechange', setBtnProps);
                return btn;
            },
            redo: () => {
                const btn = document.createElement('exeditor-toolbar-button');
                Object.assign(btn, {
                    label: this.editor.t('重做'),
                    shortcut: 'Mod-y',
                    onclick: () => {
                        this.editor.focus().redo();
                    },
                }).appendChild(createIcon({
                    name: 'redo',
                    editor: this.editor,
                    fallback: () => import('./icon.js').then((m) => m.redoIcon),
                }));
                const setBtnProps = () => {
                    btn.disabled = !this.editor.canRedo();
                };
                setBtnProps();
                this.editor.on('idlechange', setBtnProps);
                return btn;
            },
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
}
//# sourceMappingURL=index.js.map